<template>
    <v-container fluid>
        <v-layout>
            <v-flex><h1 class="display-2">Control de conteo</h1></v-flex>
        </v-layout>

        <v-layout>
            <v-flex xs12 sm4>
                <v-autocomplete :items="eventos"
                          :loading="loadingEventos"
                          label="Seleccione evento"
                          v-model="evento"
                          item-text="desig"
                          item-value="id"
                          @input="actualizaTodo">
                </v-autocomplete>
            </v-flex>
            <v-flex>
                <v-btn @click.native="actualizaTodo" dark color="primary">Actualizar</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 sm6>
                <div class="headline">Referencias</div>
                <v-container fluid grid-list-md>
                    <v-layout>
                        <template v-for="ref in referencias">
                            <v-flex>
                                <v-card :color="ref.color" class="white--text" raised hover>
                                    <v-layout row>
                                        <v-flex>
                                            <v-card-title primary-title>
                                                <div>
                                                    <div class="headline text-uppercase">{{ ref.total }}</div>
                                                    <div class="text-uppercase">{{ ref.ref }}</div>
                                                </div>
                                            </v-card-title>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </template>
                    </v-layout>

                </v-container>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card raised>
                    <v-card-title primary-title>
                        <div>
                            <div class="headline">Contado vs Stock</div>
                            <div class="subheading">Muestra la diferencia entre lo contado y lo que hay actualmente en stock.</div>
                        </div>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="items" :loading="loading">
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.item.deposito.desig }}</td>
                            <td class="text-xs-left"><b>{{ props.item.producto_id }}</b> | {{ props.item.desc }}</td>
                            <td class="text-xs-right">{{ props.item.lote_id }}</td>
                            <td class="text-xs-right">{{ props.item.stock }} {{ props.item.um }}</td>
                            <td class="text-xs-center">
                                <v-icon :color="props.item.color">{{ props.item.dif }}</v-icon>
                            </td>
                            <td class="text-xs-right">{{ props.item.cant }} {{ props.item.um }}</td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import mixinEvento from '../../mixins/stock/evento'

    export default {
        name: "control",
        mixins: [mixinEvento],
        data() {
            return {
                loading: false,
                loadingEventos: false,
                loadingRef: false,
                headers: [
                    {text: 'Deposito', value: 'deposito.desig', align: 'center'},
                    {text: 'Producto', value: 'producto_id', align: 'center'},
                    {text: 'Lote', value: 'lote_id', align: 'center'},
                    {text: 'Saldo en stock', value: 'stock', align: 'center'},
                    {text: 'Diff', value: '', align: 'center'},
                    {text: 'Contado', value: 'cant', align: 'center'},
                ],
                items: [],
                evento: '',
                eventos: [],
                referencias: []
            }
        },
        mounted() {
            this.loadingEventos = true;
            this.eventoList(r => {
                this.eventos = r;
                this.loadingEventos = false;
            }, err => {
                console.log(err);
                this.loadingEventos = false;
            })
        },
        methods: {
            actualizaTodo() {
                this.getContadoStock();
                this.getReferencias();
            },
            getContadoStock() {
                this.loading = true;
                this.eventoContadoStock({evento_id: this.evento}, r => {
                    this.items = r;
                    this.loading = false;
                }, err => {
                    this.loading = false;
                })
            },
            getReferencias() {
                this.loadingRef = true;
                this.eventoReferencias({evento_id: this.evento}, r => {
                    this.referencias = r;
                    this.loadingRef = false;
                }, err => {
                    this.loadingRef = false;
                })
            }
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/stock/control.vue